import type { PublicSlotKey } from '@/apilib';
import type { BlocksApi } from './blocksApi';

export const BlocksApiKey: PublicSlotKey<BlocksApi> = {
  name: 'BlocksApi',
  public: true,
};
